module.exports = __webpack_public_path__ + "img/tahoe-paddleboarder.1d401957.jpg";